import React, {Component} from 'react';
import {
    api, apis, db_tables, DBHelpers, errors,
    isLogin, msg, rd, route, routes, sendGet, throws, type_modal, type_modal_icon
} from "../../vars/rd";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoCategory from "../../modules/dao/category";
import DaoMain from "../../modules/dao/main";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {toObjectFromQuery} from "../../modules/func";
import {$shutils} from "../../libs/snnh/snnh";
import {modalShow} from "../../libs/redux/actions/modal";
import {jsi} from "../../index";


class AuthLoginProcess extends Component {
    msg;
    mounted = false;
    constructor(props) {
        super(props);
        if(isLogin()) route(routes.main);

        this.msg = msg();

        const query = props.location.search;
        if(!query) route(routes.login);

        this.state = toObjectFromQuery(query);
    }

    async componentDidMount() {
        this.mounted = true;
        DBHelpers.openDB()
            .then(async db => {
                // 히스토리 삭제
                await db.deleteAll(db_tables.history);

                const users = await db.select(db_tables.users, () => true) || {};
                if(this.mounted) {
                    users.shopid = this.state.id;
                    users.mac = this.state.mac || null;
                    users.groupid = this.state.groupid || null;
                    users.serviceid = this.state.serviceid || null;

                    this.setState({users}, async () => {
                        if (!this.state.groupid || !this.state.serviceid) await this.login();
                        else await this.magazine();
                    });
                }
            })
            .catch(e => errors(e));
    }

    async componentWillUnmount() {
        this.mounted = false;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * 로그인
     * @returns {Promise<void>}
     */
    async login() {
        try {
            const args = {
                id: this.state.id,
                pw: this.state.pw || '',
                mac: this.state.mac || '',
                auth_code: this.state.auth_code || '',
            };
            const json = await sendGet(api(apis.login, args));
            if(this.mounted) {
                if(!json || json.result !== "OK") throws(this.msg.api_fail);
                if(json.status === "OK") {
                    const users = {
                        ...this.state.users,
                        shopid: json.id,
                        mac: json.mac || null,
                        groupid: json.groupid || null,
                        serviceid: json.serviceid || null,
                    };

                    if(!users.groupid) throws(this.msg.empty_groupid);
                    if(!users.serviceid) throws(this.msg.empty_serviceid);

                    this.setState(
                        { users },
                        async () => {
                            rd.user.setUser(json);

                            DBHelpers.openDB().then(async db => {
                                if(!this.state.users.id) {
                                    await db.insert(db_tables.users, {...this.state.users, use_mobile: 'Y', regist: $shutils.current});
                                } else {
                                    await db.updateBulk(db_tables.users, this.state.users, (doc) => {
                                        return doc.id === this.state.users.id
                                    });
                                }
                            });

                            // 로그인 단계 매거진 인출
                            await this.magazine();
                        }
                    )
                } else throws(json.message || this.msg.json_fail);
            }
        } catch (e) {
            this.dispatch(
                modalShow(
                    type_modal.alert,
                    {
                        icon: type_modal_icon.error,
                        header: this.msg.login,
                        message: e.message
                    },
                    async () => await this.logout()
                )
            );
        }
    }

    /**
     * 로그아웃
     * @returns {Promise<void>}
     */
    async logout() {
        try {
            // 히스토리 삭제
            DBHelpers.openDB().then(async db => await db.deleteAll(db_tables.users));
        } finally {
            this.setState({...this.state, id: '', mac: ''}, () => {
                setTimeout(
                    () => jsi.jsi_logout(),
                    500
                );
            });
        }
    }

    /**
     * 매거진
     * @returns {Promise<void>}
     */
    async magazine() {
        this.dispatch(preloaderShow());

        if(jsi && typeof jsi.jsi_set_page_code === "function") {
            jsi.jsi_set_page_code('home');
        }

        const url = api(apis.magazine, {
            groupid: this.state.users.groupid,
            serviceid: this.state.users.serviceid,
        });
        sendGet(url)
            .then(async json => {
                if(this.mounted) {
                    if (!json || json.result !== "OK") throws(json.message || this.msg.api_fail);
                    if (json.status !== "OK") throws(json.message || this.msg.json_fail);

                    // business
                    if (json.hasOwnProperty('business')) {
                        rd.category.business = [];
                        (json.business || []).forEach(business => {
                            rd.category.business.push(new DaoCategory(business));
                        });
                    }

                    // genre
                    if (json.hasOwnProperty('genre')) {
                        rd.category.genre = [];
                        (json.genre || []).forEach(genre => {
                            rd.category.genre.push(new DaoCategory(genre));
                        });
                    }

                    // tempo
                    if (json.hasOwnProperty('tempo')) {
                        rd.category.tempo = [];
                        (json.tempo || []).forEach(tempo => {
                            rd.category.tempo.push(new DaoCategory(tempo));
                        });
                    }

                    // ment
                    if (json.hasOwnProperty('cmCategory')) {
                        rd.category.ment = json.cmCategory;
                    }

                    // theme
                    if (json.hasOwnProperty('theme')) {
                        rd.category.theme = [
                            new DaoCategory({
                                proid: 'all',
                                parid: null,
                                proname: "전체",
                                order: 1,
                                class: "all",
                                color: "#000000",
                                image: null
                            }),
                            new DaoCategory({
                                proid: 'best',
                                parid: null,
                                proname: "라임덕 BEST",
                                order: 2,
                                class: "best",
                                color: "#FFAB1C",
                                image: '/images/theme-best.png'
                            })
                        ];
                        (json.theme || []).forEach(theme => {
                            rd.category.theme.push(new DaoCategory(theme));
                        });
                    }

                    // shop
                    if (json.hasOwnProperty('shop')) {
                        const shop = json.shop;
                        if (shop) {
                            rd.user.serviceid = shop.serviceid;

                            // business 가 prodid 아니고 code임
                            if (!!shop.business) {
                                (rd.category.business || []).forEach(
                                    /** @param business {DaoCategory} */
                                    business => {
                                        if (business.code === shop.business) {
                                            rd.user.business = business.proid;
                                        }
                                    }
                                );
                            }
                            rd.user.bizid = shop.bizid;
                            rd.user.bizname = shop.bizname;
                            rd.user.end = shop.end;
                            rd.user.groupid = shop.groupid;
                            rd.user.id = shop.id;
                            rd.user.mac = shop.mac;
                            rd.user.serviceid = shop.serviceid;
                            rd.user.shopid = shop.shopid;
                            rd.user.shopname = shop.shopname;
                            rd.user.profile_img = shop.profile_img;
                            rd.user.mobile = shop.mobile;
                            rd.user.zipcode = shop.zipcode;
                            rd.user.address = shop.address;
                            rd.user.address_detail = shop.address_detail;

                            if(!rd.user.id) throws(this.msg.empty_id);
                            if(!rd.user.groupid) throws(this.msg.empty_groupid);
                            if(!rd.user.serviceid) throws(this.msg.empty_serviceid);
                            if(!rd.user.isPeriod) throws(this.msg.empty_period);

                            const docs = {
                                shopid: shop.id,
                                bizid: shop.bizid,
                                groupid: shop.groupid,
                                serviceid: shop.serviceid,
                                mac: shop.mac,
                                login: $shutils.current
                            };

                            DBHelpers.openDB()
                                .then(async db => {
                                    if(!this.state.users.id) {
                                        await db.insert(db_tables.users, {...docs, use_mobile: 'Y', regist: $shutils.current});
                                    } else {
                                        await db.updateBulk(db_tables.users, docs, (doc) => {
                                            return doc.id === this.state.users.id
                                        });
                                    }
                                });
                        }
                    }
                    rd.main = new DaoMain().setData(json);


                    route(!rd.user.shopBusinessExists ? routes.business : routes.main);
                }
            })
            .catch(async e => {
                this.dispatch(
                    modalShow(
                        type_modal.alert,
                        {
                            icon: type_modal_icon.error,
                            header: this.msg.magazine,
                            message: e.message
                        },
                        async () => await this.logout()
                    )
                );
            })
            .finally(() => {
                // 프리로더 제거
                this.dispatch(preloaderHide());
            });
    }


    render() {
        return (
            <div className="login">

            </div>
        );
    }
}

export default connect()(withRouter(AuthLoginProcess));


// WEBPACK FOOTER //
// ./src/pages/auth/login.process.jsx